const About = () => {
  return (
    <section id="about" className="section">
      <h2>About Me</h2>
      <p>
        I am a Junior Full-Stack Developer with an AI focus, working primarily
        with React, TypeScript, Node.js, and SQL, and comfortable building
        across the stack on Linux-based development environments. Alongside my
        web work, I am actively developing my skills in Python and machine
        learning, including a specialization that is currently in progress.
        I&apos;ve also studied the ethics and regulations of AI, and I&apos;m
        continuing my AI education so I can design solutions that are both
        technically strong and responsible.
      </p>
    </section>
  );
};

export default About;
